import React from 'react';
import { useLanguage } from 'FielderUtils/Contexts/LanguageContext';
import NoCellIcon from '@mui/icons-material/NoCell';
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly';
import { LastUpdateText } from '../Dashboard.styles';
import Grid from '@mui/material/Grid2';

const AgentLastUpdate = ({ lastUpdate }) => {
	const lan = useLanguage();
	return (
		<Grid container alignItems='center'>
			<Grid size='auto'>
				{lastUpdate ? <MobileFriendlyIcon /> : <NoCellIcon />}
			</Grid>
			<Grid size>
				<LastUpdateText>{lastUpdate ? lastUpdate : lan.notAvailable}</LastUpdateText>
			</Grid>
		</Grid>
	);
};
export default React.memo(AgentLastUpdate);
